import useFetchCompradores from '../../../hooks/compradores/useFetchCompradores';
import { IPedido } from '../../../interfaces/pedido.interface';
import Botao from '../../Botao';

interface CardPedidoProps {
  pedido: IPedido;
  detalhes: () => void;
  excluir: () => void;
}

const CardPedido = ({ pedido, detalhes, excluir }: CardPedidoProps) => {
  const { compradores } = useFetchCompradores();

  const comprador = compradores.find(c => c.id === pedido.compradorId);
  const nomeComprador = comprador ? comprador.razaoSocial : 'Comprador não encontrado';

  return (
    <>
      <div style={styles.card}>
        <h2>Pedido Nº {pedido.numeroPedido}</h2>
        <p><strong>Comprador:</strong> {nomeComprador}</p>
        <p><strong>Data do Pedido:</strong> {pedido.dataPedido ? new Date(pedido.dataPedido).toLocaleDateString() : 'Data não disponível'}</p>
        <p><strong>Observações:</strong> {pedido.observacoes || 'Nenhuma'}</p>

        <div style={styles.container}>
          <Botao text={'Detalhes'} onClick={detalhes} />
          <Botao text={'Excluir'} onClick={excluir}/>  
        </div>
      </div>
    </>
  );
};

const styles = {
  card: {
    border: '1px solid #ddd',
    borderRadius: '8px',
    padding: '16px',
    margin: '16px 0',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
    maxWidth: '400px',
    backgroundColor: '#f9f9f9'
  },
  container: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%'
  },
};

export default CardPedido;
